
import { Traduccion, TraduccionFiltro } from "@/model/Traduccion";
import { TraduccionService } from "@/services/TraduccionService";
import { Constantes } from "@/Util/Constantes";
import { HeaderTemplate, Utilidades } from "@/Util/Utilidades";
import Vue from "vue";

export default Vue.extend({
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      headers: new Array<Object>() as Array<HeaderTemplate>,
      busqueda: "" as string,
      loading: false as boolean,
      traduccion: new Array<Object>() as Array<Traduccion>,
    };
  },
  mounted() {
    this.montarHeaders();
  },
  methods: {
    async cargarTags() {
      this.loading = true;
      this.traduccion = new Array<Object>() as Array<Traduccion>;
      let filtro = new Object() as TraduccionFiltro;
      filtro.pagina = this.$store.state.page;

      await TraduccionService.getTagsPagina(filtro)
        .then((x) => (this.traduccion = x.data))
        .catch((x) =>
          Utilidades.Message({
            message: Constantes.ERROR_CARGAR_DATOS,
            error: true,
          })
        );

      this.loading = false;
    },
    montarHeaders() {
      this.headers = new Array<Object>() as Array<HeaderTemplate>;
      this.headers.push(
        Utilidades.nuevoHeader({ text: "Tag", value: "tag_texto" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Texto", value: "texto" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Idioma", value: "nombre_idioma" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Texto Idioma", value: "texto_idioma" })
      );
    },
  },
});
